"use strict";

var _slicedToArray = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/slicedToArray.js");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var testCondition_1 = __importDefault(require("./testCondition"));

var verifyCondition = function verifyCondition(_ref) {
  var formValues = _ref.formValues,
      test = _ref.test;
  var valid = [];
  var testArray = !Array.isArray(test) ? [test] : test;
  testArray.forEach(function (_ref2) {
    var field = _ref2.field,
        operator = _ref2.operator,
        value = _ref2.value;

    if (field && formValues) {
      var fieldArray = field.split('.');
      var fieldValue = fieldArray.reduce(function (acc, tmp) {
        if (acc) {
          if (tmp && tmp.split('[').length > 1) {
            // c'est un tableau
            var _tmp$slice$split = tmp.slice(0, tmp.length - 1).split('['),
                _tmp$slice$split2 = _slicedToArray(_tmp$slice$split, 2),
                newTmp = _tmp$slice$split2[0],
                index = _tmp$slice$split2[1];

            if (Object.keys(acc).includes(newTmp) && acc[newTmp][index]) {
              return acc[newTmp][index];
            }
          } else if (Object.keys(acc).includes(tmp)) {
            return acc[tmp];
          }
        }

        return undefined;
      }, formValues); // if (undefined !== fieldValue) {

      valid.push((0, testCondition_1.default)({
        fieldValue: fieldValue,
        operator: operator,
        value: value
      })); // } else {
      // valid.push(false);
      // }
    }
  });
  return !valid.some(function (val) {
    return !val;
  });
};

exports.default = verifyCondition;